import Speaker2Att from "../Attendees/Speaker2Att";
import Header2 from "../Bookings/Header2";
import Footer from "../Home/Footer";
import Speaker2 from "../Home/Speaker2";
import HeroSpeaker from "./HeroSpeaker";

const Speaker = () => {
    return (
<div>
<Header2/>
<HeroSpeaker/>

<Speaker2Att/>
<Footer/>

</div>

);
};

export default Speaker;
